export const getPdfHR = {
    //Gumb za preuzimanje pdf-a
    "download_pdf_button": "Preuzmi"
}